export const INCREASE_PROGRESS = 'INCREASE_PROGRESS';
export const RESET_APP = 'RESET_APP';
export const SET_ACTIVE_SCREEN = 'SET_ACTIVE_SCREEN';
export const SET_PROGRESS = 'SET_PROGRESS';
export const START_OVER = 'START_OVER';
